import { matchPath } from 'react-router';

import { PageTags, Params } from './types';

class ProfilePageTags extends PageTags {
  static get({ pathname, exact }: Params) {
    let currentPage = '';
    // eslint-disable-next-line no-restricted-syntax
    for (const [path] of Object.entries(this.container)) {
      const currentRoutePath = matchPath(pathname, { path, exact });
      if (currentRoutePath) {
        currentPage = path;
        break;
      }
    }

    if (this.container[currentPage]) {
      return this.container[currentPage];
    }
    return undefined;
  }

  static get container(): {[key: string]: string[]} {
    return {
      '/dashboard/profile/me': this.me,
      '/dashboard/admin/profile/billing': this.billing,
    };
  }

  static get me() {
    return [
      'tag:user',
      'tag:profile',
      'tag:detail',
    ];
  }

  static get billing() {
    return [
      'tag:user',
      'tag:billing',
      'tag:detail',
    ];
  }
}


export default ProfilePageTags;
